export default __webpack_public_path__ + "static/media/rnr-sports-table-16.78ddb5a7.webp";